<template>
    <section class="d-flex flex-column h-full">
        <header class="mdc-top-app-bar">
            <div class="mdc-top-app-bar__row">
                <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                    <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button"
                        aria-label="Open navigation menu" @click="closeImage" @keypress="closeImage" tabindex="0">close</button>
                </section>
            </div>
        </header>
        <main class="mdc-top-app-bar--fixed-adjust flex-grow-1 scroll-y bg-primary">
            <div class="d-flex align-items-center justify-content-center h-full ">
                <div class="image-view-container square-image h-auto">
                    <img :src="previewimageUrl" alt="" v-if="previewimageUrl">

                </div>
            </div>
        </main>
    </section>
</template>
<script>

export default {
	props: ['previewimageUrl'],
	data() {
		return {}
	},
	
	mounted() {},
    methods:{
        closeImage(){
            this.$emit('closePreview')
        }
    }
}
</script>
